export class ServerClock {
  private samples: { offset: number; rtt: number }[] = [];
  add(sent: number, received: number, server: number): void {
    if (![sent, received, server].every(Number.isFinite) || received < sent || received - sent > 10000) return;
    this.samples.push({ offset: server - (sent + received) / 2, rtt: received - sent });
    if (this.samples.length > 16) this.samples.shift();
  }
  get estimate(): { offset: number; uncertainty: number; samples: number } | null {
    if (!this.samples.length) return null;
    const sorted = [...this.samples].sort((a, b) => a.rtt - b.rtt);
    // A shader compilation or main-thread stall can delay a pong by hundreds of
    // milliseconds. Once a fast sample exists, do not keep that outlier in the
    // offset/uncertainty estimate merely because the window has <3 samples.
    const best = sorted.filter(sample => sample.rtt <= sorted[0]!.rtt + 20).slice(0, 3);
    return {
      offset: best.reduce((n, s) => n + s.offset, 0) / best.length,
      uncertainty: Math.max(...best.map(s => s.rtt / 2)),
      samples: this.samples.length,
    };
  }
  reset(): void { this.samples = []; }
}
